/* eslint-disable camelcase */
import classNames from "classnames";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import NotificationCircle from "components/atoms/NotificationCircle";
import { makeLangUrl } from "helpers/makeLangUrl";
import { useGTM } from "hooks/useGTM";
import useTranslate from "hooks/useTranslate";
import { useChatwootInit } from "hooks/useChatwootInit";
import { useSelector } from "react-redux";
import * as authSelectors from "redux/auth/selectors";
import { useDialogWindowStore } from "stores/dialogWindow";
import { useRouterHistoryStore } from "stores/routerHistory";
import { setLocalStorageItem } from "utils/localStorage";
import { useSupport } from "hooks/useSupport";
import { GET_POPUP_TYPES } from "../../../constants/popupConfig";
import { STORAGE_SIDE_MENU } from "../../../constants/variables";
import {
  TABBAR_NAVIGATION_ENUM,
  TabbarType,
} from "../../../constants/navigation/tabbar";
import "./styles.sass";

export type TabbarItemProps = {
  item: TabbarType;
  hasNotify: boolean;
};

const TabbarItem = (props: TabbarItemProps) => {
  // eslint-disable-next-line react/destructuring-assignment
  const { id, icon, title, location } = props.item;
  const { hasNotify } = props;

  const t = useTranslate();
  const navigate = useNavigate();
  const locationUrl = useLocation();
  const supportInit = useSupport();
  const GTM = useGTM();
  const setIsOpen = useDialogWindowStore((state) => state.setIsOpen);
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const setPreviousPage = useRouterHistoryStore(
    (state) => state.setPreviousPage,
  );
  const chatWootInit = useChatwootInit();
  const isUrlActive = (currentLocation: string, targetLocation: string) =>
    currentLocation === targetLocation;
  const isActive = isUrlActive(locationUrl.pathname, location.toString());

  const isSideMenuOpen =
    locationUrl.search.includes(GET_POPUP_TYPES.popup.sideMenu) &&
    id === TABBAR_NAVIGATION_ENUM.MENU;

  useEffect(() => {
    setLocalStorageItem(STORAGE_SIDE_MENU, "");
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const onClickHandler = (id: number) => {
    if (window.$chatwoot) {
      window.$chatwoot.toggleBubbleVisibility("hide");
    }
    if (id === TABBAR_NAVIGATION_ENUM.SUPPORT) {
      chatWootInit();
      return;
    }

    const chatwootWidgetHolder = document.querySelector(
      ".woot-widget-holder",
    ) as HTMLElement;
    if (chatwootWidgetHolder) {
      chatwootWidgetHolder.style.setProperty("z-index", "1", "important");
    }

    if (locationUrl.search.includes(GET_POPUP_TYPES.popup.sideMenu)) {
      setIsOpen(false);
      if (id !== TABBAR_NAVIGATION_ENUM.MENU) {
        if (id === TABBAR_NAVIGATION_ENUM.DEPOSIT) {
          setLocalStorageItem(STORAGE_SIDE_MENU, "?popup=deposit");
          GTM.clickDepTB();
        } else {
          if (id === TABBAR_NAVIGATION_ENUM.CASINO) {
            GTM.clickCasinoTB();
          } else if (id === TABBAR_NAVIGATION_ENUM.SUPPORT) {
            // GTM.clickFavoriteTB();
            supportInit();
          }
          setLocalStorageItem(STORAGE_SIDE_MENU, location);
        }
      }
    } else {
      if (id === TABBAR_NAVIGATION_ENUM.MENU) {
        GTM.clickMenuTB();
      } else if (id === TABBAR_NAVIGATION_ENUM.CASINO) {
        GTM.clickCasinoTB();
      } else if (id === TABBAR_NAVIGATION_ENUM.DEPOSIT) {
        GTM.clickDepTB();
        if (location?.search === "?popup=deposit") {
          if (isAuthenticated) {
            navigate(location);
            return;
          }
          navigate(makeLangUrl("?popup=sign-up"));
          return;
        }
      } else if (id === TABBAR_NAVIGATION_ENUM.SUPPORT) {
        supportInit();
        // GTM.clickFavoriteTB();
      }

      if (typeof location === "string") {
        navigate(makeLangUrl(String(location)));
      } else {
        navigate(makeLangUrl(String(location.search)));
      }

      setPreviousPage(`${locationUrl.pathname}${locationUrl.search}`);
    }
  };

  const tabbarIconClass = classNames("TabbarItem__icon", {
    TabbarItem__icon_active:
      isActive && !locationUrl.search.includes(GET_POPUP_TYPES.popup.sideMenu),
    TabbarItem__icon_dep: id === TABBAR_NAVIGATION_ENUM.DEPOSIT,
    TabbarItem__icon_other: id !== TABBAR_NAVIGATION_ENUM.DEPOSIT,
  });

  const tabbarTitleClass = classNames("TabbarItem__title", {
    TabbarItem__title_dep: id === TABBAR_NAVIGATION_ENUM.DEPOSIT,
  });

  return (
    <div className="TabbarItem" onClick={() => onClickHandler(id)} key={id}>
      <div className={tabbarIconClass}>
        {hasNotify ? (
          <NotificationCircle className="TabbarItem__icon_notify" />
        ) : null}
        {icon}
      </div>
      <div className={tabbarTitleClass}>
        {t(isSideMenuOpen ? "language.select.close" : title)}
      </div>
    </div>
  );
};
export default TabbarItem;
